import { Download, Loader2, MessageCircle, Trash2, AlertTriangle, Share2 } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VideoCard = ({ video, onDelete }) => {
  const url = `${API}/videos/${video.id}/file`;
  const tid = video.id.slice(0, 8);

  const download = async () => {
    const res = await fetch(url);
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `ac-creator-3d-video-${tid}.mp4`;
    a.click();
    URL.revokeObjectURL(a.href);
  };

  const share = async () => {
    try {
      const blob = await (await fetch(url)).blob();
      const file = new File([blob], `ac-creator-3d-${tid}.mp4`, { type: "video/mp4" });
      if (navigator.canShare?.({ files: [file] })) await navigator.share({ files: [file], title: "AC Creator 3D" });
      else { await navigator.clipboard.writeText(url); toast.success("Link copiato"); }
    } catch {}
  };

  const whatsapp = () => {
    const msg = `Guarda il nuovo video di *AC Creator 3D*! 🎬\n\n👉 ${url}`;
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(msg)}`, "_blank");
  };

  return (
    <div data-testid={`video-card-${tid}`} className="bg-card border border-white/10 rounded-sm p-4">
      {video.status === "completed" ? (
        <video data-testid={`video-player-${tid}`} src={url} controls playsInline preload="metadata" className="w-full max-h-[420px] rounded-sm bg-black" />
      ) : video.status === "processing" ? (
        <div data-testid={`video-processing-${tid}`} className="h-40 flex flex-col items-center justify-center text-muted-foreground bg-black/40 rounded-sm">
          <Loader2 className="w-8 h-8 animate-spin text-neon-cyan mb-2" />
          <p className="text-sm font-light">{video.stage || "In creazione…"}</p>
        </div>
      ) : (
        <div data-testid={`video-failed-${tid}`} className="h-28 flex flex-col items-center justify-center text-neon-pink bg-black/40 rounded-sm px-3 text-center">
          <AlertTriangle className="w-6 h-6 mb-1" />
          <p className="text-xs">{video.error || "Generazione non riuscita"}</p>
        </div>
      )}
      <p className="text-sm text-white mt-3 line-clamp-2">{video.mode === "ai" && <span className="text-[10px] font-mono uppercase text-neon-pink mr-2">Scene AI</span>}{video.mode === "clips" && <span className="text-[10px] font-mono uppercase text-neon-cyan mr-2">Gemini</span>}{video.title || video.description || video.scene_prompt}</p>
      <p className="text-[11px] font-mono text-muted-foreground mt-1">{video.mode === "clips" && video.status === "processing" ? "…" : `${Math.round(video.duration)}s`} · {video.aspect_ratio}{video.music ? " · musica" : ""}{video.narration ? " · voce" : ""} · {new Date(video.created_at).toLocaleString("it-IT")}</p>
      <div className="flex flex-wrap gap-2 mt-3">
        {video.status === "completed" && (
          <>
            <Button size="sm" data-testid={`video-download-${tid}`} onClick={download} variant="outline" className="rounded-sm gap-1 border-white/15"><Download className="w-4 h-4" /> Scarica</Button>
            <Button size="sm" data-testid={`video-share-${tid}`} onClick={share} variant="outline" className="rounded-sm gap-1 border-white/15"><Share2 className="w-4 h-4" /> Condividi</Button>
            <Button size="sm" data-testid={`video-whatsapp-${tid}`} onClick={whatsapp} className="rounded-sm gap-1 bg-[#25D366] text-black hover:bg-[#1ebe5b]"><MessageCircle className="w-4 h-4" /> WhatsApp</Button>
          </>
        )}
        {video.status !== "processing" && (
          <Button size="sm" data-testid={`video-delete-${tid}`} onClick={() => onDelete(video.id)} variant="ghost" className="rounded-sm gap-1 text-muted-foreground hover:text-neon-pink"><Trash2 className="w-4 h-4" /></Button>
        )}
      </div>
    </div>
  );
};
